import { useRef } from 'react';
import Autoplay from 'embla-carousel-autoplay';
import { FileText, Users, Heart, Shield, TrendingUp } from 'lucide-react';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from '../ui/carousel';

const REASONS = [
  { Icon: FileText, title: '"Winging It" Isn\'t a Plan', copy: 'Most Americans spend more time planning a vacation than retirement. According to Fidelity, 61% don\'t know how much they need. We help you figure it out now, without the panic.' },
  { Icon: Users, title: 'We Speak Human', copy: 'Some advisors talk in acronyms. Zivae breaks it down in warm, simple language so clear anyone can understand. Money shouldn\'t feel like quantum physics.' },
  { Icon: Heart, title: 'Customized Plans', copy: 'No cookie-cutter PDFs. We look at your goals, lifestyle, timeline, and even your "one day I\'m moving to Bali" dreams. Only 35% of Americans have a written plan—we put you in the confident category.' },
  { Icon: Shield, title: 'Tax-Smart Strategies', copy: 'The average American loses 25-30% of lifetime wealth to taxes. We specialize in tax-efficient income, Social Security optimization, and legally keeping more of what you earn.' },
  { Icon: TrendingUp, title: 'Coaching & Care', copy: 'Retirement isn\'t just math; it\'s mindset. Research shows 72% of financial decisions are influenced by emotions. We blend planning with lifestyle coaching and wealth-mindset development.' },
];

export const ReasonsCarousel = () => {
  const plugin = useRef(Autoplay({ delay: 4500, stopOnInteraction: false }));
  return (
    <Carousel plugins={[plugin.current]} opts={{ loop: true }} className="w-full" data-testid="reasons-carousel">
      <CarouselContent>
        {REASONS.map(({ Icon, title, copy }, i) => (
          <CarouselItem key={title} className="md:basis-1/2">
            <div className="glass-panel rounded-3xl p-8 md:p-10 h-full" data-testid={`reason-card-${i + 1}`}>
              <div className="flex items-center justify-between mb-8">
                <div className="w-14 h-14 rounded-2xl bg-orange-500/15 border border-orange-400/30 flex items-center justify-center">
                  <Icon className="w-7 h-7 text-orange-300" />
                </div>
                <span className="font-serif-accent italic text-5xl text-white/15">0{i + 1}</span>
              </div>
              <h3 className="font-display text-2xl font-semibold text-white mb-4">{title}</h3>
              <p className="text-slate-300 leading-relaxed">{copy}</p>
            </div>
          </CarouselItem>
        ))}
      </CarouselContent>
      <div className="flex gap-3 mt-8 justify-end">
        <CarouselPrevious data-testid="reasons-prev" className="static translate-y-0 bg-white/5 border-white/15 text-white hover:bg-orange-500 hover:text-white" />
        <CarouselNext data-testid="reasons-next" className="static translate-y-0 bg-white/5 border-white/15 text-white hover:bg-orange-500 hover:text-white" />
      </div>
    </Carousel>
  );
};
